import React from "react";
import PrepararToDo from "./Checklists/preparar";
import ChegadaToDo from "./Checklists/chegada";
import LocaisToDo from "./Checklists/locais";
import BackBTN from "../BTN/BackBTN";
import { useHistory } from "react-router-dom";
import { withNamespaces } from 'react-i18next'; 

const ToDoList = ({t}) => {
  const goToPreviousPath = () => {
    history.goBack()
  }
  let history = useHistory();

  return (
    <div className="container ToDoList">
            <div className="mt-3 mb-3">
        <BackBTN click={goToPreviousPath} title={t('moduleBotoes:B6.Title')} texto={t('moduleBotoes:B6.B')} />
      </div>
      <div className="mt-4 marginB_title">
        <div className="col-12">
          <h2>{t('moduleToDoList:T')}</h2>
          <div className="orange_line"></div>
        </div>
      </div>
      <div className="marginB_title todo_filter">
        <div className="dropdown filter_todo">
          <button
            className="btn dropdown-toggle col-12"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <p className="text-filter">{t('moduleToDoList:D.T')}</p>
          </button>
          <ul
            className="dropdown-menu col-12"
            aria-labelledby="dropdownMenuButton1"
          >
            <li>
              <a className="dropdown-item todo_option" href="#1">
              {t('moduleToDoList:D.P1')}
              </a>
            </li>
            <li>
              <a className="dropdown-item todo_option" href="#2">
              {t('moduleToDoList:D.P2')}
              </a>
            </li>
            <li>
              <a className="dropdown-item todo_option" href="#3">
              {t('moduleToDoList:D.P3')}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div id="checkslists-section" className="row marginB_section">
          <PrepararToDo/>
          <ChegadaToDo/>        
          <LocaisToDo/>
      </div>
    </div>
  );
};
export default withNamespaces() (ToDoList);
